import Vue from 'vue';
import Router from 'vue-router';

import page404 from './views/page404.vue';


import RetailersForm from './views/RetailersForm.vue';
import RetailersSearch from './views/RetailersSearch.vue';
import RetailersBeforeResults from './views/RetailersBeforeResults.vue';
import RetailersResults from './views/RetailersResults.vue';
import RetailersBook from './views/RetailersBook.vue';



import store from "./store/store";
import e from 'cors';


Vue.use(Router)





const router = new Router({
  mode: 'history',
  base: '/retailers/',
  routes: [{
      path: '*',
      name: 'RetailersForm',
      component: RetailersForm
    },

    {
      path: '/',
      name: 'RetailersForm',
      component: RetailersForm
    },

    {
      path: '/search',
      name: 'RetailersSearch',
      component: RetailersSearch
    },

    {
      path: '/show-results',
      name: 'RetailersBeforeResults',
      component: RetailersBeforeResults
    },
    {
      path: '/results',
      name: 'RetailersResults',
      component: RetailersResults
    },
    {
      path: '/book',
      name: 'RetailersBook',
      component: RetailersBook
    },


  ]
})


// router.beforeEach((to, from, next) => {
//   const loggedUser = !!$cookies.get('user_name') && $cookies.get('user_token');

//   if (to.matched.some(m => m.meta.authGuard) && !loggedUser)
//     next({
//       name: "Login"
//     });
//   else next();
// });

export default router